export const colors = {
    iisightBrand: "#51AD4C",
    iisightBrand700: "#3D823A",
    iisightBrand900: "#063602",
    iisightGreen100: "#F1F8F0",
    iisightGray100: "#F6F6F6",
    iisightGray200: "#ACACAC",
    iisightGray400: "#6F6F6F",
    iisightGray700: "#4B4B4B",
    iisightGray900: "#202020",
    iisightBlue500: "#0191B4",
    iisightBlue700: "#01657e",
    iisightBlue900: "#013d4c",
    iisightWhite: "#ffffff",
    iisightBlack: "#000000",
    error03: "#7A141F",
    error04: "#A21B29",
    error05: "#CB2233",
    error06: "#D83848",
    error08: "#F24D5F",
    primary01: "#00112D",
    primary02: "#00225A",
    primary03: "#003486",
    primary04: "#0045B3",
    primary05: "#0056E0",
    primary06: "#246FE5",
    primary07: "#4687ED",
    primary08: "#99BBF3",
    primary09: "#CCDDF9",
    surface01: "#040404",
    surface02: "#141414",
    surface03: "#292929",
    surface04: "#3D3D3D",
    surface05: "#525252",
    surface06: "#666",
    surface07: "#858585",
    surface08: "#A3A3A3",
    surface09: "#C2C2C2",
    surface10: "#E0E0E0",
    surface11: "#FFF",
    success04: "#189B55",
    success05: "#1EC26A",
    warning05: "#F8AE1A",
    warning06: "#FFD600",
    support01: "#FF9B42",
    support02: "#F96E57",
    support03: "#DF486F",
    support04: "#B23683",
    support05: "#73348C",
    support06: "#6A50D3",
    support07: "#4380E2",
    support08: "#00A8B3",
    support09: "#2AA076"
};
export const colorMap = {
    iisightBrand: "iisightBrand",
    iisightBrand700: "iisightBrand700",
    iisightDarkBrand: "iisightBrand900",
    iisightBrand900: "iisightBrand900",
    iisightGreen100: "iisightGreen100",
    iisightGray100: "iisightGray100",
    iisightGray200: "iisightGray200",
    iisightGray400: "iisightGray400",
    iisightGray700: "iisightGray700",
    iisightGray900: "iisightGray900",
    iisightBlue500: "iisightBlue500",
    iisightBlue700: "iisightBlue700",
    iisightBlue900: "iisightBlue900",
    iisightWhite: "iisightWhite",
    iisightBlack: "iisightBlack",
    iisightWhiteBackground: "iisightWhite",
    iisightBlackBackground: "iisightBlack",
    iisightDarkBrandBackground: "iisightBrand900",
    iisightBrandBackground: "iisightBrand",
    iisightHeader: "iisightBrand",
    iisightDefaultText: "iisightGray400",
    iisightWhiteText: "iisightWhite",
    iisightIcon: "iisightGray200",
    uiBackground: "surface01",
    ui01: "surface02",
    ui02: "surface03",
    ui03: "surface04",
    ui04: "surface05",
    ui05: "surface06",
    ui06: "surface07",
    ui07: "surface08",
    ui08: "surface09",
    ui09: "surface10",
    ui10: "surface11",
    action01: "primary06",
    action01Hover: "primary07",
    action01Active: "primary04",
    action02: "surface10",
    action02Hover: "surface11",
    action02Active: "surface09",
    actionDanger: "error05",
    actionDangerHover: "error06",
    actionDangerActive: "error04",
    action03: "transparent",
    action03Hover: "surface04",
    action03Active: "surface03",
    disabled01: "surface09",
    focus01: "primary07",
    link01: "primary07",
    link01Hover: "primary08",
    link01Active: "primary06",
    text01: "surface11",
    text02: "surface09",
    text03: "surface07",
    text04: "surface01",
    textError: "error08",
    icon01: "surface11",
    icon02: "surface09",
    icon03: "surface07",
    icon04: "surface01",
    iconError: "error06",
    field01: "surface04",
    success01: "success05",
    success02: "success04",
    warning01: "warning05",
    warning02: "warning06",
    support01: "support01",
    support02: "support02",
    support03: "support03",
    support04: "support04",
    support05: "support05",
    support06: "support06",
    support07: "support07",
    support08: "support08",
    support09: "support09"
};
export const font = {
    weightRegular: 400,
    weightSemiBold: 600
};
export const shape = {
    borderRadius: 6,
    circleRadius: 50,
    boxShadow: 'inset 0px -1px 0px rgba(255, 255, 255, 0.15)'
};
export const spacing = [0, 4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128];
export const typography = {
    labelRegular: 'label01',
    labelBold: 'labelBold01',
    bodyShortRegularSmall: {
        fontSize: '0.625rem',
        lineHeight: '1rem',
        fontWeight: font.weightRegular,
        letterSpacing: 0
    },
    bodyShortRegular: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        fontWeight: font.weightRegular,
        letterSpacing: 0
    },
    bodyShortBold: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    bodyShortRegularLarge: {
        fontSize: '1rem',
        lineHeight: '1.375rem',
        fontWeight: font.weightRegular,
        letterSpacing: 0
    },
    bodyShortBoldLarge: {
        fontSize: '1rem',
        lineHeight: '1.375rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    bodyLongRegular: {
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        fontWeight: font.weightRegular,
        letterSpacing: 0
    },
    bodyLongRegularLarge: {
        fontSize: '1rem',
        lineHeight: '1.625rem',
        fontWeight: font.weightRegular,
        letterSpacing: 0
    },
    bodyLongBold: {
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    bodyLongBoldLarge: {
        fontSize: '1rem',
        lineHeight: '1.625rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    heading1: 'heading01',
    heading2: 'heading02',
    heading3: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    heading4: {
        fontSize: '1.75rem',
        lineHeight: '2.25rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    heading5: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    },
    heading6: {
        fontSize: '1rem',
        lineHeight: '1.625rem',
        fontWeight: font.weightSemiBold,
        letterSpacing: 0
    }
};
export const breakpoints = {
    values: {
        '0': 0,
        '320': 320,
        '400': 400,
        '480': 480
    }
};
